// Public (no-auth) site flags from GET /api/settings/public: hide_about_page, hide_beta_banner.
// Cached for the tab so the public header doesn't refetch (and flicker) on every page change;
// call refreshPublicConfig() after an admin changes one of the flags.
import { useEffect, useState } from 'react';
import axios from 'axios';

const DEFAULTS = { hide_about_page: false, hide_beta_banner: false };
const TTL_MS = 60000;
let cache = null;      // { at, data }
let inflight = null;

export function loadPublicConfig() {
  if (cache && Date.now() - cache.at < TTL_MS) return Promise.resolve(cache.data);
  if (!inflight) {
    inflight = axios.get('/api/settings/public')
      .then(res => { cache = { at: Date.now(), data: { ...DEFAULTS, ...(res.data || {}) } }; return cache.data; })
      .catch(() => (cache ? cache.data : DEFAULTS))
      .finally(() => { inflight = null; });
  }
  return inflight;
}

export function refreshPublicConfig() { cache = null; return loadPublicConfig(); }

/** null until loaded (first visit only), then the flags. */
export function usePublicConfig() {
  const [cfg, setCfg] = useState(cache ? cache.data : null);
  useEffect(() => {
    let active = true;
    loadPublicConfig().then(d => { if (active) setCfg(d); });
    return () => { active = false; };
  }, []);
  return cfg;
}
